export enum EProductType {
    LEEDPULSE = 'leedpulse',
    LEEDFLOW = 'leedflow',
}
  
export const productTypeAsString = (type: EProductType | string): string => {
    switch (type) {
        case EProductType.LEEDPULSE:
            return "Leedpulse";
        case EProductType.LEEDFLOW:
            return "Leedflow";
        default:
            return type.toString();
    }
};

export const productTypeAsPrefix = (type: EProductType | string): string => {
    switch (type) {
        case EProductType.LEEDPULSE:
            return "lp";
        case EProductType.LEEDFLOW:
            return "lf";
        default:
            return type.toString();
    }
};